import PageLayout from "layouts/PageLayout";
import TableData from "./tableData";

function Contact() {
  return (
    <PageLayout
      title={'Contact'}
    >
      <TableData />
    </PageLayout>
  );
}

export default Contact;
